import cx from 'clsx';
import * as React from 'react';

import * as styles from './CategoryTabs.css';
import { ESpoilerCategoryRequest, ISuburbanOfferHistorySpoilerFilters } from '../../../../store/offerHistory';

interface ICategoryTabsProps extends Omit<ISuburbanOfferHistorySpoilerFilters, 'activeCategory'> {
  activeCategory: ESpoilerCategoryRequest | undefined;
  onTabClick: (category: ESpoilerCategoryRequest) => void;
}

export const CategoryTabs: React.FC<React.PropsWithChildren<ICategoryTabsProps>> = ({
  activeCategory,
  categories,
  onTabClick,
}) => {
  return (
    <ul className={styles['category-tabs']} data-testid="offers_history_categories">
      {categories.map(({ label, value }) => (
        <li
          onClick={() => onTabClick(value)}
          key={value}
          className={cx(styles['tab'], activeCategory === value && styles['active'])}
        >
          {label}
        </li>
      ))}
    </ul>
  );
};
